export default "__VITE_ASSET__BHcguCXC__"